/** Type of Agency multi-select options (buxusweb `AgencyInfoForm`). */
export const TYPE_OF_AGENCY_OPTIONS = [
  "Airport",
  "Constable",
  "Emergency Dispatch",
  "Emergency Management",
  "Fire",
  "HAZMAT",
  "Industrial",
  "Law Enforcement",
  "LEPC",
  "Medical",
  "Military",
  "Non-Emergency Dispatch (Secondary)",
  "Police",
  "Primary PSAP",
  "Private Company",
  "Sheriff",
] as const;

/** Zoho Staffed picklist values (same as CRM display labels). */
export const STAFFED_OPTIONS = ["Paid", "Volunteer", "Combination"] as const;

/**
 * `Can_your_department_provide` options collected in registration (UI alphabetizes).
 * Radio gear is on Dispatch. CRM still has "UHF / VHF" (`DEPARTMENT_PROVIDE_CRM_ONLY_OPTIONS`)
 * and historic Yes/Nos for capabilities now on this picklist — do not delete those.
 * Do not add "800 Trunk radios" here (`Have_800_Trunk_radios` stays historic Yes/No).
 */
export const DEPARTMENT_PROVIDE_OPTIONS = [
  "Earth moving equipment",
  "Tanker trucks",
  "Foam capabilities",
  "Spill Boom",
  "Gas monitoring equipment",
  "Rural water supply",
  "Master stream capabilities",
  "Reverse 911",
  "LEL detection",
  "LFL detection",
  "Dry chemical extinguishers",
  "CO2 monitoring",
  "Drone",
  "Medical assistance",
  "Directing traffic",
  "Radio communication with other responding agencies",
  "Computers or mobile on scene internet access",
] as const;

/**
 * Values that remain on Zoho `Can_your_department_provide` but are not collected in registration
 * (radio questions consolidated on Dispatch). Keep these option values in CRM — historic rows
 * still hold them, and deleting CRM picklist options can break concurrent / older clients that
 * still submit them.
 */
export const DEPARTMENT_PROVIDE_CRM_ONLY_OPTIONS = ["UHF / VHF"] as const;

export const HAZWOPER_OPTIONS = [
  "Awareness",
  "Operations",
  "Technician",
  "Specialist",
  "Incident Commander",
  "Not Applicable",
] as const;

/**
 * How did you find out about Buxus®? Keep alphabetized.
 *
 * Zoho CRM API names (How_Did_You_Find_Out_About_Buxus_* series — keep this convention;
 * Zoho may overwrite API names if Field Label is edited after create):
 *   - How_Did_You_Find_Out_About_Buxus (picklist)
 *   - How_Did_You_Find_Out_About_Buxus_Agency        ← Agency → "What agency?"
 *   - How_Did_You_Find_Out_About_Buxus_Association  ← Association
 *   - How_Did_You_Find_Out_About_Buxus_Conference   ← Conference
 *   - How_Did_You_Find_Out_About_Buxus_Operator      ← Operator
 *   - How_Did_You_Find_Out_About_Buxus_Trainer       ← Training
 *   - How_Did_You_Find_Out_About_Buxus_Webinar       ← Webinar
 *   POST body keys (BuxusAccountSetup): how_did_you_find_out_about_buxus_*
 */
export const HOW_DID_YOU_FIND_OUT_ABOUT_BUXUS_OPTIONS = [
  "Agency",
  "Association",
  "Conference",
  "Electronic media",
  "Email",
  "Friend",
  "Mailing",
  "Operator",
  "Training",
  "Webinar",
] as const;
